import React from "react";
import MultiModalPickerWithChooseButton from "../MultiModalPickerWithChooseButton";
import { MultiModalPickerProps } from "../props";
import MultiArtistList from "./MultiArtistList";
import { LabelList } from "../LabelList";

interface Props extends MultiModalPickerProps<server.dto.ArtistSmall> {
  securityScope: server.dto.ArtistSecurityScopes;
  hideActiveFilter?: boolean;
}

export const ArtistMultiModalPicker = (props: Props) => {

  return <>
    <MultiModalPickerWithChooseButton<server.dto.ArtistSmall>
      onNewClicked={() => { }}
      renderLabelContent={(artist) => <div>{artist.name}</div>}
      getId={(artist) => artist.artistId}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.functionGroups.artist.plural}
      modalSize="small"
      renderModalContent={(editedValue, setEditedValue) => <MultiArtistList
        securityScope={props.securityScope}
        hideActiveFilter={!!props.hideActiveFilter}
        excludeKeys={editedValue.map(artist => artist.artistId)}
        onChange={setEditedValue}
        value={editedValue}
      />}

      {...props}
    />
  </>;
};

export const SelectedArtists = (props: { value: server.dto.ArtistSmall[] }) => {
  return <LabelList
    value={props.value}
    renderLabelContent={(artist) => <div>{artist.name}</div>}
    getId={(artist) => artist.artistId}
  />;
}